export enum AceSoftwareRevenueDeliveryModelEnum {
  CONTRACT = 'Contract',
  PAY_AS_YOU_GO = 'Pay-as-you-go',
  SUBSCRIPTION = 'Subscription',
}
